import { render, staticRenderFns } from "./NfreshDeliveryRow.vue?vue&type=template&id=b8e2c972&scoped=true&"
import script from "./NfreshDeliveryRow.vue?vue&type=script&lang=ts&"
export * from "./NfreshDeliveryRow.vue?vue&type=script&lang=ts&"
import style0 from "./NfreshDeliveryRow.vue?vue&type=style&index=0&id=b8e2c972&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e2c972",
  null
  
)

export default component.exports